<!--tabs: Rewards' segmented control look (track, segment shape and shadow); own label styles-->
<div
  class="tw-flex tw-w-full tw-items-center tw-gap-1 tw-rounded-2xl tw-bg-color-segmented-container-bg tw-p-1 tw-mb-6"
>
  @for (tab of tabs; track tab) {
    @let isActive = tab === tabActive();
    <button
      type="button"
      (click)="onTabClick(tab)"
      class="tw-flex-1 tw-h-9 tw-flex tw-items-center tw-justify-center tw-border-0 tw-cursor-pointer tw-rounded-xl tw-text-[14px] tw-font-medium tw-transition-all tw-duration-200"
      [ngClass]="
        isActive
          ? 'tw-bg-color-surface-elevated tw-text-dt-text-action tw-shadow-segmented'
          : 'tw-bg-transparent tw-text-dt-text-tertiary'
      "
    >
      {{ tab }}
    </button>
  }
</div>

<ng-content></ng-content>
